<template>
  <div class=" mt-5 ">
    <v-layout row wrap>
      <v-flex>
        <section>
          <div>
            <div class="text-center ">
              <div class="fs-24 font_weight_600 black_one">
                Informasi mengenai profil Anda
              </div>

              <div class="black_three mt-1">
                Lengkapi seluruh informasi profil untuk membuat akun yang akan anda gunakan
              </div>
            </div>


            <div class="mt-5">
              <v-row justify="center">
                <v-col cols="7">
                  <v-card class="box-shadow">
                    <v-card-text class="pa-6">
                      <ValidationObserver 
                        ref="form">
                        <v-form>
                          <div class="fs-14 mb-1 black_two">
                            Nama Lengkap
                            <span class="red--text">*</span>
                          </div>
                          <ValidationProvider 
                            name="Nama Lengkap" 
                            rules="required" 
                            v-slot="{ errors }">
                            <v-text-field
                              v-on:keyup.enter="save"
                              class="no_box mb-3"
                              outlined
                              hide-details
                              dense
                              :color="set_color"
                              style="border-radius: 4px;"
                              placeholder="Masukkan nama lengkap anda"

                              vv-uppercase

                              v-model="form.name"
                              :error-messages="errors"
                              required>
                            </v-text-field>
                          </ValidationProvider>

                          <div class="fs-14 mb-1 black_two">
                            Nomor HP (WhatsApps)
                            <span class="red--text">*</span>
                          </div>
                          <ValidationProvider 
                            name="Nomor HP (WhatsApps)" 
                            rules="required" 
                            v-slot="{ errors }">
                            <v-text-field
                              v-on:keyup.enter="save"
                              class="no_box mb-3"
                              outlined
                              hide-details
                              dense
                              :color="set_color"
                              style="border-radius: 4px;"
                              prefix="+62"
                              placeholder="Masukkan nomor WhatsApps untuk verifikasi akun Anda"

                              vv-uppercase

                              v-model="form.mobilephone"
                              :error-messages="errors"
                              required>
                            </v-text-field>
                          </ValidationProvider>


                          <div class="fs-14 mb-1 black_two">
                            Jabatan
                            <span class="red--text">*</span>
                          </div>
                          <ValidationProvider 
                            name="Jabatan" 
                            rules="required" 
                            v-slot="{ errors }">
                            <v-text-field
                              v-on:keyup.enter="save"
                              class="no_box mb-3"
                              outlined
                              hide-details
                              dense
                              :color="set_color"
                              style="border-radius: 4px;"
                              placeholder="Masukkan Jabatan anda"

                              vv-uppercase

                              v-model="form.position"
                              :error-messages="errors"
                              required>
                            </v-text-field>
                          </ValidationProvider>

                          <div class="fs-14 mb-1 black_two">
                            Email
                            <span class="red--text">*</span>
                          </div>
                          <ValidationProvider 
                            name="Email" 
                            rules="required|email" 
                            v-slot="{ errors }">
                            <v-text-field
                              v-on:keyup.enter="save"
                              class="no_box mb-3"
                              outlined
                              hide-details
                              dense
                              :color="set_color"
                              style="border-radius: 4px;"
                              placeholder="Masukkan alamat email untuk verifikasi akun Anda"

                              vv-uppercase

                              v-model="form.email"
                              :error-messages="errors"
                              required>
                            </v-text-field>
                          </ValidationProvider>

                          <div class="fs-14 mb-1 black_two">
                            Kata Sandi
                          </div>
                          <ValidationProvider 
                            name="Kata Sandi" 
                            rules="required|min:5|max:20" 
                            v-slot="{ errors }">
                            <v-text-field
                              v-on:keyup.enter="save"
                              class="no_box mb-3"
                              outlined
                              hide-details
                              dense
                              :color="set_color"
                              style="border-radius: 4px;"
                              placeholder="Buat kata sandi untuk masuk ke akun Anda"
                              :type="show ? 'text' : 'password'"
                              :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                              @click:append="show = !show"
                              :counter="20"

                              vv-uppercase
                              
                              v-model="form.password"
                              :error-messages="errors"
                              required>
                            </v-text-field>
                          </ValidationProvider>
                        </v-form>
                      </ValidationObserver>
                      <div
                        
                      class="text-center my-4 d-flex align-center">
                      <div v-if="message.error.length > 0"
                        class="error--text">
                        <v-icon size="18" color="red">mdi-alert-circle-outline</v-icon>
                        
                        <span
                          class="ml-1">
                          {{ message.error }}
                        </span>
                      </div>
                    </div>
                    </v-card-text>
                    <v-card-text style="background: #FAFAFA" class="px-6 py-4 text-right">
                      <!-- <v-btn
                        outlined
                        height="36"
                        :to="`/register/jenis-usaha`"
                        style="border-radius: 6px;"
                        elevation="0"
                        :loading="process.form"
                        :disabled="process.form || form.jenis_usaha === ''"
                        class="text-capitalize">
                        Sebelumnya
                      </v-btn> -->
                      <v-btn
                        color="#240087"
                        height="36"
                        elevation="0"
                        @click="save()"
                        style="border-radius: 6px;"
                        :loading="process.form"
                        :disabled="process.form || form.jenis_usaha === ''"
                        class="white--text text-capitalize ml-3">
                        Lanjutkan
                      </v-btn>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </div>
          </div>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { TokenService } from "@/service/Storage.Service";
  import { get, post, put, patch, destroy } from "@/service/Axios";
  export default {
    data() {
      return {
        show: false,
        form: {
          business_type: '',
          name: '',
          position: '',
          mobilephone: '',
          email: '',
          password: '',
        },
        process: {
          form: false
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    computed: {
      rps() {
        return this.$vuetify.breakpoint.name
      },
      company () {
        return this.$store.state.company
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r+35}, ${g+37}, ${b}, 0.97)`
      }
    },
    mounted () {
      // this.form.business_type = (this.$route.params.id).split('-').join(' ')
    },
    methods: {
      async save () {
        this.message.error = ''

        const isValid = await this.$refs.form.validate()
        if (isValid) {
          this.process.form = true
          let form = {
            // business_type: this.form.business_type,
            name: this.form.name,
            position: this.form.position,
            mobilephone: `0${this.form.mobilephone}`,
            email: this.form.email,
            password: this.form.password,
          }

          await post('pos/auth/register', {
            data: form
          })
          .then(response => {
            let res = response.data

            if (res.status === 200) {
              // console.log(res.results.data.mobile_key)

              // window.location = `${process.env.BASE_URL}dashboard`
                this.$router.push({ path: `/verification-phone/${this.form.mobilephone}?key=${res.results.data.mobile_key}` })
              

            } else {
              this.process.form = false
              this.message.error = res.message
            }
          })
        }
      }
    }
  }
</script>